
import { Component, Inject, OnInit } from '@angular/core';


@Component({
  template: `
  <router-outlet></router-outlet>
`
})
export class AlterarCautelaGrupoComponent implements OnInit {
 
  constructor(){}
  ngOnInit(): void {
      
  }
}